'use client';

import './style.sass';

import React from 'react';

import {
    listCompanies,
    listCreateDotProject,
    listCreateDotProjectProcessMinus,
    listCreateDotProjectProcessPlus,
    listCreateNumberProject,
    listDefaultBlock,
    listDescription,
    listDescriptionAnalytic,
    listDescriptionBd,
    listDescriptionContent,
    listDescriptionMarketing,
    listDescriptionProcess,
    listDescriptionProcessDev,
    listDescriptionResult,
    listDescriptionRoles,
    listDescriptionSecurity,
    listIntegration,
    listMarketing,
    listPath,
    listRec,
    listResultInfo,
    listResultInfoDev,
    listTarget,
    listTeam,
    listTitle,
} from './constants';

import NextProject from '../../cases/reusable-components/layouts-components__common-cases/next-project';
import DefaultListImage from '../../cases/reusable-components/new-rec/default-list-image';
import DefaultResultList from '../../cases/reusable-components/new-rec/default-result-list';
import DefaultText from '../../cases/reusable-components/new-rec/default-text';
import TargetCase from '../../case-components/target-case';
import DescriptionCase from '../../case-components/description-case';
import DefaultDotList from '../../case-components/default-dot-list';
import DefaultNumberList from '../../case-components/default-number-list';
import TitleCase from '../../case-components/title-case';
import TeamCase from '../../case-components/team-case';

const nextProjectdevRec = {
    nextProjectTitle: 'Узкие ключи и&nbsp;контентное SEO: кейс ОТП Банка',
    nextProjectImg: '/images/pic/otp-bank/otp-bank.jpg',
    nextProjectLink: '/cases/marketing/otp-bank',
    nextProjectLinkTitle: 'Маркетинг',
    nextProjectText:
        'В&nbsp;этом кейсе расскажем, как с&nbsp;помощью SEO за&nbsp;один год сотрудничества с&nbsp;ОТП Банком добились высоких позиций в&nbsp;выдаче по&nbsp;ключевым запросам, увеличили поисковой трафик и&nbsp;общую видимость сайта.',
};

const NewRec = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/new-rec/rec.jpg"
                caseName="rec"
                listPath={listPath}
                listTitle={listTitle}
            />

            <TargetCase listTarget={listTarget} />

            <DescriptionCase
                listDescription={listDescription}
                customClass="default"
                customChildrenClass="padding"
            />

            <DefaultDotList
                listCreateDotProject={listCreateDotProject}
                customClass="defaultColor"
            />

            <DefaultNumberList listCreateNumberProject={listCreateNumberProject} />

            <DescriptionCase
                listDescription={listDescriptionProcess}
                customClass="default"
                customChildrenClass="reverse"
            />

            <DefaultDotList
                listCreateDotProject={listCreateDotProjectProcessPlus}
                customClass="greenColor"
            />

            <DefaultDotList
                listCreateDotProject={listCreateDotProjectProcessMinus}
                customClass="redColor"
            />
            <DescriptionCase listDescription={listDescriptionProcessDev} customClass="default" />

            <DefaultResultList listResultInfo={listResultInfoDev} customClass="development" />

            <DescriptionCase
                listDescription={listDescriptionBd}
                customClass="customTitle"
                customChildrenClass="start"
            />

            <DefaultText listDefaultBlock={listDefaultBlock} />

            <DescriptionCase listDescription={listDescriptionSecurity} customClass="start" />

            <DescriptionCase listDescription={listDescriptionRoles} customClass="start" />

            <DefaultListImage listIntegration={listIntegration} />

            <DescriptionCase listDescription={listDescriptionContent} customClass="start" />

            <DefaultListImage listIntegration={listRec} customClass="customOrders" />

            <DefaultListImage listIntegration={listCompanies} customClass="customImage" />

            <DescriptionCase listDescription={listDescriptionMarketing} customClass="end" />

            <DefaultListImage listIntegration={listMarketing} customClass="defaultOrders" />

            <DescriptionCase listDescription={listDescriptionAnalytic} customClass="end" />

            <DescriptionCase listDescription={listDescriptionResult} customClass="default" />

            <DefaultResultList listResultInfo={listResultInfo} />
            <TeamCase listTeam={listTeam} />
            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default NewRec;
